module.exports = __webpack_public_path__ + "images/skillzWhiteLogo-7293867df783903e16a76b3877fd15d9.png";